import { FormattedMessage } from 'react-intl';
import { Divider, Icon } from '@ets/design-system';

import { FormattedDate } from '_common/components';

import styles from './DueDateBanner.module.scss';
import dayjs from 'dayjs';
import { useMemo } from 'react';

type DueDateBannerProps = {
  dueDate: ISODate;
  divider?: boolean;
};

const DueDateBanner = ({ dueDate, divider }: DueDateBannerProps) => {
  //Will be due in [dueDiff] days:
  //If negative, is due by [dueDiff] days:
  const dueDiff = useMemo(() => dayjs(dueDate).diff(dayjs(), 'days'), [dueDate]);

  if (!dayjs(dueDate).isValid()) {
    return null;
  }

  if (dueDiff < 0) {
    return (
      <div className={`${styles.dueDate} ${styles.isDue}`}>
        <Icon size="2" icon="calendar" color="error" testId="due-date-overdue" />
        <FormattedMessage id="DUE_DATE_IS_OVERDUE_BY_DAYS" values={{ days: Math.abs(dueDiff) }} />
      </div>
    );
  }

  if (dueDiff <= 2) {
    return (
      <div className={`${styles.dueDate} ${styles.dueSoon}`}>
        <Icon size="2" icon="calendar" color="warning" testId="due-date" />
        <FormattedMessage
          id="DUE_DATE_IS"
          values={{ dueDate: <FormattedDate date={dueDate} type="simplistic" /> }}
        />
      </div>
    );
  }

  return (
    <>
      {divider && <Divider margin="0" />}
      <div className={`${styles.dueDate} ${styles.notDue}`}>
        <Icon size="2" icon="calendar" color="primary" testId="due-date" />
        <FormattedMessage
          id="DUE_DATE_IS"
          values={{ dueDate: <FormattedDate date={dueDate} type="simplistic" /> }}
        />
      </div>
    </>
  );
};

export default DueDateBanner;
